export const HTTP_SUBSTATUS = {
  401: {
    TOKEN_EXPIRED: 42,
  },
};
